import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getDashboardData } from "../Store/Thunk";
import Overlay from "../../../SharedComponents/Overlay";
import { AppCard } from "./AppCard/AppCard";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DemographyForm from "../../Demography";
import MobileWarningModal from "./MobileWarningModal";
import { isMobileDevice } from "../../../../Helpers/DeviceHelper";

export default function UserDash() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.userDash.isLoading);
  const demographyFormIsShown = useSelector((state) => state.selectedCandidateDemography.isShown);
  const [showMobileWarning, setShowMobileWarning] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    dispatch(getDashboardData());

    // Check if user is on mobile device
    const mobileCheck = isMobileDevice();
    setIsMobile(mobileCheck);

    // Show warning modal if on mobile
    if (mobileCheck) {
      setShowMobileWarning(true);
    }
  }, []);

  return (
    <Row className={"mx-0"}>
      <Col>
        {isLoading && <Overlay />}
        {demographyFormIsShown && <DemographyForm></DemographyForm>}
        <MobileWarningModal show={showMobileWarning} onClose={() => setShowMobileWarning(false)} />
        <AppCard isOnlyNonFinished={true} isMobile={isMobile} />
      </Col>
    </Row>
  );
}
